<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar="cancelar"
    >
      <template slot="conteudo">
        <b-row>
          <b-form-group
            label="Razão Social"
            class="col-md-6"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Razão social"
            >
              <b-form-input
                v-model="form.razaoSocial"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-col cols="3">
            <b-form-group label="CNPJ/CPF">
              <validation-provider
                #default="{ errors }"
                :rules="'required|' + validacao"
                name="CNPJ/CPF"
              >
                <masked-input
                  v-model="form.cnpj"
                  :mask="mascaraCadastroFederal"
                  :pipe="pipeCadastroFederal"
                  class="form-control"
                  :disabled="disableCnpj"
                  placeholder-char=" "
                  placeholder="CNPJ ou CPF para cadastro"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label="Plano">
              <masked-input
                :disabled="true"
                class="form-control"
                :placeholder="nomePlanoFormatado"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-form-group
            label="E-mail"
            class="col-md-12"
          >
            <validation-provider
              #default="{ errors }"
              rules="required|email"
              name="E-mail"
            >
              <b-form-input v-model="form.email" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-row>

        <!-- Adicionado: Checkbox para validação em duas etapas -->
        <b-row class="mb-3">
          <b-col cols="12">
            <b-form-checkbox
              id="checkbox-validacao-duas-etapas"
              v-model="form.flgValidacaoDuasEtapas"
              name="checkbox-validacao-duas-etapas"
              switch
            >
              Ativar validação em duas etapas
            </b-form-checkbox>
            <small class="text-muted">
              A validação em duas etapas adiciona uma camada extra de segurança à sua conta.
            </small>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <upload-e-visualizacao
              ref="upload"
              :value="form.logo"
            />
          </b-col>
        </b-row>
      </template>
    </cadastro-base>
  </div>
</template>

<script>
import { cpfDocumento, cnpjDocumento } from '@pilar/plugins/p-validation/p-validation'
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import CadastroBase from '@pilar/components/cadastro-base/CadastroBase.vue'
import { PlanUtils } from '@pilar/utils/planUtils'
import api from './shared/services/api'

export default {
  name: 'Proprietario',
  components: {
    CadastroBase,
    ValidationProvider,
    UploadEVisualizacao: () => import('@pilar/plugins/upload-e-visualizacao/UploadEVisualizacao.vue'),
  },
  data() {
    return {
      cpfDocumento,
      cnpjDocumento,
      required,
      form: {
        id: null,
        cnpj: null,
        razaoSocial: null,
        email: null,
        logo: null,
        flgValidacaoDuasEtapas: false,
      },
      immutableForm: {},
      maskApplied: 0,
      isAlteracao: false,
      disableCnpj: true,
      validacao: '',
    }
  },
  computed: {
    /**
     * Retorna o nome formatado do plano baseado no tipoPlano
     * @returns {string} Nome do plano formatado
     */
    nomePlanoFormatado() {
      return PlanUtils.obterNomePlanoFormatado(this.form.tipoPlano)
    },
  },
  created() {
    this.carregar()
  },
  methods: {
    carregar() {
      api.get()
        .then(payload => {
          this.form = payload.data
          if (!this.form) {
            this.form = {}
          } else {
            this.isAlteracao = true
            this.setDisableCnpj()
          }
        })
        .catch(err => {
          throw err
        })
    },
    salvar() {
      return new Promise((resolve, reject) => {
        const form = { ...this.form }
        form.logo = null

        const formData = this.$refs.upload.getFormDataBody(form)
        api.update(formData)
          .then(payload => {
            const acao = this.isAlteracao ? 'alterado' : 'cadastrado'
            resolve(`Perfil empresa ${acao} com sucesso`)

            this.form.id = payload.data
            this.isAlteracao = !this.isAlteracao ? true : this.isAlteracao

            this.setDisableCnpj()
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    setDisableCnpj() {
      this.disableCnpj = !!(this.form.cnpj && this.form.cnpj !== '')
      this.mascaraCadastroFederal()
    },
    cancelar() {
      this.$router.push({ name: 'dashboard-analitico' })
    },
    isCnpj() {
      return this.form.cnpj
        && this.form.cnpj
          .replaceAll(' ', '')
          .replaceAll('.', '')
          .replace('-', '')
          .replace('/', '').length > 11
    },
    mascaraCadastroFederal() {
      const alfanumerico = /[A-Za-z0-9]/
      if (this.isCnpj()) {
        this.validacao = 'cnpjDocumento'
        return [alfanumerico, alfanumerico, '.', alfanumerico, alfanumerico, alfanumerico, '.', alfanumerico, alfanumerico, alfanumerico, '/', alfanumerico, alfanumerico, alfanumerico, alfanumerico, '-', /\d/, /\d/]
      }

      this.validacao = 'cpfDocumento'
      return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]
    },
    // CNPJ Alfanumérico deve ser sempre exibido em maiúsculas (padrão RFB)
    pipeCadastroFederal(valorConformado) {
      return valorConformado.toUpperCase()
    },
  },
}
</script>
